import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import {
  fetchExternalClientDetails,
  checkIsWBSEValid
} from "../../../redux/fui/index";
import { Checkbox, FormControlLabel, FormGroup, FormLabel, Grid, Select, MenuItem, InputLabel } from "@material-ui/core";
import {
  StyledFormControl,
  StyledDefaultTextField,
  StyledTextField,
  StyledSelect,
} from "../FuiStyles";
import { checkWBSECode } from "./CommonFunctions";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import GeneralForm from "./GeneralForm";
import * as fuiRedux from "../../../redux/fui/index";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from './useFormValidationWithBorders';
import { ExpandLess } from "@material-ui/icons";
import { DateTextFieldCommonComponent } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";


/**
 * Plain Instance Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const DedicatedVirtualNetworkSetup = ({
  values,
  updateCPForm,
  configurationType,
  classes,
  history,
  email,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  isLoading,
  checkIsWBSEValid,
  isWBSEValid,
  formClickSubmit,
  notesValidations,
  // Props passed but not used (kept to avoid prop warnings)
  selectedEnvironment,
  minDate,
  maxDate,
  serviceEndDateValue,
  isServiceEndDateInvalid,
  getSelectedEnvironment,
  getServiceEndDate,
  getNotesValue,
  setIsAllValid,
  createdBy,
  vendorName,
  getSelectedClientname,
  getSAPContractIDValue,
  selectedClientname,
  sapContractIdValue
}) => {

  const config = configurationType === "quick";

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [expandDetails, setExpandDetails] = useState(false);
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isChecked, setIsChecked] = useState(false);


  useEffect(() => {
    if (config) {
      // Clear client-specific fields for quick config
      updateCPForm("ClientName", "")
      updateCPForm("ProjectName", "")
      updateCPForm("EndToEndUId", "")
      updateCPForm("SAPContractID", "")
      updateCPForm("Company", "")
      updateCPForm("AvanadeCountry", "")
      updateCPForm("AccentureCountry", "")
      // Reset SAP contract code length when switching to quick config
      setSapContractCodeLength("0");
      // Reset project name validity when switching to quick config
      setIsProjectNameValid(true);
    }
  }, [config]);



  // get user's input
  const handleChange = (e, fieldName) => {
    const bakes = {}
    bakes[fieldName] = e.target.value
  
    
    if (fieldName === "Apps") {
      const baks = {}
      if(e.target.checked){
        baks[e.target.name] = true
      }
      else {
        baks[e.target.name] = false
        // Clear instance type when app is unchecked
        setAppInstanceTypes({...appInstanceTypes, [e.target.name]: ''})
      }
      setAppsIntegList({...appsIntegList, ...baks})
    } else if (fieldName === "AppInstanceType") {
      setAppInstanceTypes({...appInstanceTypes, [e.target.name]: e.target.value })
    } else if (fieldName === "ProjectName") {
      const value = e.target.value;
      if (value.length > 32 || value.length < 3) {
        setIsProjectNameValid(false);
      } else {
        setIsProjectNameValid(true);
      }
      updateCPForm("ProjectName", value);
    } else {
      // Clear deployment region when GDPR changes to avoid invalid selections
      if (fieldName === "GDPR") {
        setFormData({ ...formData, ...bakes, DeploymentRegion: '' })
      }
      // Clear connectivity type when CloudPlatform is not AWS
      else if (fieldName === "CloudPlatform" && e.target.value !== "aws") {
        setFormData({ ...formData, ...bakes, ConnectivityType: '' })
      }
      // Handle DataClassification changes for approvers-enhanced compatibility
      else if (fieldName === "DataClassification") {
        if (e.target.value === "Client-NonProduction") {
          setFormData({ ...formData, ...bakes, Environment: "Dev", DeploymentPhase: "" });
        } else if (e.target.value === "Client-Production") {
          setFormData({ ...formData, ...bakes, Environment: "Production", DeploymentPhase: "" });
        } else {
          setFormData({ ...formData, ...bakes });
        }
      }
      else {
        setFormData({ ...formData, ...bakes })
      }
    }
    
    if (fieldName === "WBSEcode") {
      const wbsevalue = e.target.value.toUpperCase()
      const isWBSEFormatValid = checkWBSECode(wbsevalue);
      if (isWBSEFormatValid) {
        checkIsWBSEValid(wbsevalue)
      }
    }

    if (fieldName === "SAPContractID") {
      const value = e.target.value;
      setSapContractCodeLength(value.length.toString());

      // Update Redux state as well
      updateCPForm("SAPContractID", value);

      // Clear previous client data when SAP Contract ID changes
      updateCPForm("ClientName", "");
      updateCPForm("EndToEndUId", "");

      // Fetch external client details when SAP Contract ID reaches 10 digits
      if (value.length === 10 && !config) {
        fetchExternalClientDetails(value);
      }
    }
  };



  const isGDPR = formData && formData.GDPR === "yes";
  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  //form validation
  const validateInputFields = (step) => {
    // If not final submit, allow navigation (no validation)
    if (step !== 'submit') {
      return true;
    }

    let ispass = true;
    const missingFields = [];

    // Final submit validation - validate ALL fields
    const allFieldsRequired = [
      'DeploymentRegion',
      'WBSEcode',
      'DataClassification',
      'LLMProvider',
      'CloudPlatform',
      'AppList',
      'RequestNotes',
      'DeliveryLead',
      'DeploymentLead',
      'SecondaryPOC'
    ];

    // Add ConnectivityType as required only when CloudPlatform is AWS
    if (formData.CloudPlatform === 'aws') {
      allFieldsRequired.push('ConnectivityType');
    }

    // Add CLIENT-specific required fields (only SAP Contract ID - others are auto-populated)
    if (!config) {
      allFieldsRequired.push('SAPContractID');
      allFieldsRequired.push('DeploymentPhase'); // Required for approvers-enhanced
      allFieldsRequired.push('ProjectName');
    }

    // Check for missing fields (basic empty validation - red borders handled by hook)
    for (const fieldname of allFieldsRequired) {
      if (fieldname === "WBSEcode") {
        // WBSE validation: empty OR API validation failed
        if (!formData[fieldname] || formData[fieldname] === "" || !isWBSEValid) {
          missingFields.push('WBSEcode');
          ispass = false;
        }
      } else if (fieldname === "AppList") {
        if (!formData[fieldname] || formData[fieldname].length === 0) {
          missingFields.push('AppList');
          ispass = false;
        }
      } else if (fieldname === "SAPContractID") {
        if (!values[fieldname] || values[fieldname] === "" || sapContractCodeLength !== "10" || externalClientError) {
          missingFields.push('SAPContractID');
          ispass = false;
        }
      } else if (fieldname === "ProjectName") {
        if (!values[fieldname] || values[fieldname] === "" || !isProjectNameValid) {
          missingFields.push('ProjectName');
          ispass = false;
        }
      } else if (fieldname === "DeliveryLead") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('DeliveryLead');
          ispass = false;
        }
      } else if (fieldname === "DeploymentLead") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('DeploymentLead');
          ispass = false;
        }
      } else if (fieldname === "DeploymentRegion") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('DeploymentRegion');
          ispass = false;
        }
      } else if (fieldname === "CloudPlatform") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('CloudPlatform');
          ispass = false;
        }
      } else if (fieldname === "ConnectivityType") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('ConnectivityType');
          ispass = false;
        }
      } else if (fieldname === "RequestNotes") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('RequestNotes');
          ispass = false;
        }
      } else if (fieldname === "LLMProvider") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('LLMProvider');
          ispass = false;
        }
      } else if (fieldname === "SecondaryPOC") {
        if (!formData[fieldname] || formData[fieldname] === "") {
          missingFields.push('Secondary POC');
          ispass = false;
        }
      }
    }

    // Validate Application Type selections for selected applications
    const selectedApps = Object.entries(appsIntegList).filter(([app, selected]) => selected);
    for (const [appName, selected] of selectedApps) {
      // Skip validation for apps with fixed types
      if (appName !== 'AgentManager' && appName !== 'EventOps' && appName !== 'SplunkTA') {
        if (!appInstanceTypes[appName] || appInstanceTypes[appName] === '') {
          missingFields.push(`Application Type for ${appName}`);
          ispass = false;
        }
      }
    }

    // Prepare form data for submission
    const dataForm = {...formData};

    // Convert AppList array to comma-separated string
    if (dataForm['AppList'] && Array.isArray(dataForm['AppList'])) {
      let temp = dataForm['AppList'].join(",");
      dataForm['AppList'] = temp;
    }

    // Add application instance types for selected applications
    const selectedAppsForSubmission = Object.entries(appsIntegList).filter(([app, selected]) => selected);
    const appInstanceTypeData = {};
    selectedAppsForSubmission.forEach(([appName, selected]) => {
      if (selected) {
        // For apps with fixed types, use the predefined type
        if (appName === 'AgentManager' || appName === 'EventOps') {
          appInstanceTypeData[`${appName}_InstanceType`] = 'serverless';
        } else if (appName === 'SplunkTA') {
          appInstanceTypeData[`${appName}_InstanceType`] = 'dedicated';
        } else {
          // For other apps, use the selected instance type
          appInstanceTypeData[`${appName}_InstanceType`] = appInstanceTypes[appName] || '';
        }
      }
    });

    // Add application instance type data to the form
    Object.assign(dataForm, appInstanceTypeData);

    // Add CLIENT-specific fields if not in quick config
    if (!config) {
      dataForm['SAPContractID'] = values.SAPContractID || '';
      dataForm['ClientName'] = values.ClientName || '';
      dataForm['EndToEndUId'] = values.EndToEndUId || '';
      dataForm['ProjectName'] = values.ProjectName || '';
    }

    // Add configuration type
    dataForm['Configuration'] = configurationType;

    // Set correct platform type for approvers API
    dataForm['AaamPlatformType'] = 'DedicatedVPC';
    dataForm['TeamName'] = 'DEDICATEDVPC';

    // Add required fields for approvers-enhanced endpoint with default values
    // Since DedicatedVPC has dedicated approvers, we use defaults for consistency
    dataForm['DataClassification'] = 'Client-Production';
    dataForm['Environment'] = 'Production';
    if (!config) {
      dataForm['DeploymentPhase'] = 'Production';
    }

    // Use the hook to handle validation results (red borders + dialog)
    handleValidationResult(ispass, missingFields, () => formClickSubmit(dataForm));
    return ispass;
  }


  const connectivityWorkflows = {
    vpn: {
      title: "Site-to-Site VPN (AWS–AWS, AWS–Azure, On-Prem)",
      combinedTasks: [
        "Step 1 (Client): Provide tunnel endpoint IP(s) and device type",
        "Step 2 (Client): Share VPN BGP/Static routing preferences",
        "Step 3 (Client): Open firewall for IPsec traffic (UDP 500, 4500)",
        "Step 4 (Client): Upload customer CIDR ranges",
        "Step 5 (Platform): Provision dedicated VPC with requested CIDRs",
        "Step 6 (Client): Confirm encryption and authentication settings",
        "Step 7 (Platform): Configure AWS VPN (VGW + IPSec Tunnel)",
        "Step 8 (Platform): Apply route tables and propagate BGP/static routes",
        "Step 9 (Platform): Enable CloudWatch tunnel monitoring",
        "Step 10 (Platform): Provide metadata and tunnel status to client",
        "Step 11 (Client): Test tunnel once notified",
        "Step 12 (Platform): Support test run and go-live readiness"
      ]
    },
    privatelink: {
      title: "PrivateLink Access (Service Endpoint)",
      combinedTasks: [
        "Step 1 (Platform): Expose service via NLB + VPC Endpoint Service",
        "Step 2 (Client): Create interface endpoint in your VPC",
        "Step 3 (Client): Attach endpoint to correct subnet and SG",
        "Step 4 (Platform): Whitelist client account ID in endpoint policy",
        "Step 5 (Platform): Publish PrivateLink endpoint details",
        "Step 6 (Client): Verify DNS resolution (if custom)",
        "Step 7 (Platform): Provide DNS and connection verification guide",
        "Step 8 (Client): Test access to SaaS service endpoint",
        "Step 9 (Platform): Monitor access logs and health"
      ]
    },
    peering: {
      title: "VPC Peering (AWS–AWS)",
      combinedTasks: [
        "Step 1 (Client): Share AWS Account ID and VPC ID",
        "Step 2 (Client): Confirm CIDR range is non-overlapping",
        "Step 3 (Platform): Initiate VPC peering request",
        "Step 4 (Client): Accept peering connection request",
        "Step 5 (Platform): Validate and apply routing in shared VPC",
        "Step 6 (Client): Update route tables to reach SaaS VPC",
        "Step 7 (Platform): Configure route tables and SG for access",
        "Step 8 (Platform): Enable basic connectivity checks",
        "Step 9 (Client): Test network connectivity",
        "Step 10 (Platform): Support test run and onboarding"
      ]
    }
  };


  const [formData, setFormData] = useState({

    DeploymentRegion: '',
    WBSEcode: '',
    LLMProvider: '',
    AppList: '',
    TentativeServiceEndDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()), // Default to 1 year from now
    CustomerEnterpriseID: email ? email.split("@")[0] : '',
    CloudPlatform: '',
    ConnectivityType: '',
    RequestNotes: '',
    GDPR: 'no', // Default to 'no' (Non-GDPR)
    DeliveryLead: '',
    DeploymentLead: '',
    SecondaryPOC: ''
  });

  const [appsIntegList, setAppsIntegList] = useState({
    KM: false,
    Steward: false,
    CUI: false,
    ATR: false,
    Codev: false,
    SplunkTA: false,
    AgentManager: false,
    EventOps: false,
  })

  const [appInstanceTypes, setAppInstanceTypes] = useState({
    KM: '',
    Steward: '',
    CUI: '',
    ATR: '',
    Codev: '',
    SplunkTA: '',
    AgentManager: '',
    EventOps: '',
  })

  const { KM, Steward, CUI, ATR, Codev, SplunkTA, AgentManager, EventOps } = appsIntegList;

  // Helper function to render instance type selection on the right
  const renderInstanceTypeSelection = (appName, appDisplayName) => {
    const isChecked = appsIntegList[appName];
    if (!isChecked) return null;

    // Fixed instance types for specific apps
    if (appName === 'AgentManager' || appName === 'EventOps') {
      // Auto-set to serverless and show as disabled dropdown
      if (appInstanceTypes[appName] !== 'serverless') {
        setAppInstanceTypes(prev => ({...prev, [appName]: 'serverless'}));
      }
      return (
        <StyledFormControl variant="outlined" size="small" style={{ minWidth: '170px' }}>
          <InputLabel style={{ fontSize: '14px' }}>Application Type</InputLabel>
          <StyledSelect
            value="serverless"
            label="Application Type"
            disabled={true}
          >
            <MenuItem value="serverless">Serverless</MenuItem>
          </StyledSelect>
        </StyledFormControl>
      );
    } else if (appName === 'SplunkTA') {
      // Auto-set to dedicated and show as disabled dropdown
      if (appInstanceTypes[appName] !== 'dedicated') {
        setAppInstanceTypes(prev => ({...prev, [appName]: 'dedicated'}));
      }
      return (
        <StyledFormControl variant="outlined" size="small" style={{ minWidth: '170px' }}>
          <InputLabel style={{ fontSize: '14px' }}>Application Type</InputLabel>
          <StyledSelect
            value="dedicated"
            label="Application Type"
            disabled={true}
          >
            <MenuItem value="dedicated">Dedicated</MenuItem>
          </StyledSelect>
        </StyledFormControl>
      );
    }

    // For other apps, show dropdown for Dedicated/Container
    return (
      <StyledFormControl variant="outlined" size="small" style={{ minWidth: '170px' }}>
        <InputLabel style={{ fontSize: '14px' }}>Application Type</InputLabel>
        <StyledSelect
          value={appInstanceTypes[appName] || ''}
          onChange={(e) => setAppInstanceTypes(prev => ({...prev, [appName]: e.target.value}))}
          label="Application Type"
        >
          <MenuItem value="">
            <em>Select Type</em>
          </MenuItem>
          <MenuItem value="dedicated">Dedicated</MenuItem>
          <MenuItem value="container">Container</MenuItem>
        </StyledSelect>
      </StyledFormControl>
    );
  };

  // Use enhanced validation hook with red borders and dialog management
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(
    formData,
    isWBSEValid,
    null, // selectedEnvironment not needed for this form
    values, // Redux values for SAP Contract ID
    {
      sapContractCodeLength,
      externalClientError,
      isExternalClientLoading
    }
  );

  // Clear local formData when Redux values are cleared (configuration type change)
  useEffect(() => {
    // Reset local formData to match cleared Redux state
    if (values.DeploymentRegion === '' && values.WBSEcode === '') {
      setFormData({
        DeploymentRegion: '',
        WBSEcode: '',
        LLMProvider: '',
        AppList: [],
        TentativeServiceEndDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()),
        CustomerEnterpriseID: email ? email.split("@")[0] : '',
        CloudPlatform: '',
        ConnectivityType: '',
        RequestNotes: '',
        vpnPattern: '',
        GDPR: 'no', // Keep default value
        DeliveryLead: '',
        DeploymentLead: '',
        SecondaryPOC: ''
      });
    }
  }, [values, email]);


  const renderWorkflowGuide = () => {
    if (!formData.ConnectivityType || !connectivityWorkflows[formData.ConnectivityType]) return null;
    const { title, combinedTasks } = connectivityWorkflows[formData.ConnectivityType];
    return (
      <div className="mb-10 p-4 border-l-4 border-purple-600 bg-gray-50 rounded">
        <h2 className="text-lg font-semibold text-purple-700 mb-2">{title} - Sequenced Milestones</h2>
        <ul className="list-decimal list-inside space-y-1 text-sm text-gray-800">
          {combinedTasks.map((task, i) => <li key={`workflow-${i}`}>{task}</li>)}
        </ul>
      </div>
    );
  };
  
  useEffect(() => {
    const bakes = []
    Object.entries(appsIntegList).map(([item,val], idx) => {
      if(val){
        bakes.push(item)
      }
    })
    formData.AppList = bakes
  },[appsIntegList])

  // Handle external client data population (SAP Contract ID auto-population)
  useEffect(() => {
    if (externalClientData && externalClientData.length >= 2 && !config) {
      const clientName = externalClientData[0] || '';
      const endToEndUId = externalClientData[1] || '';

      // Update Redux state only
      updateCPForm("ClientName", clientName);
      updateCPForm("EndToEndUId", endToEndUId);
    }
  }, [externalClientData, config]);

  return (
    <>
      <GeneralForm
        FormId={11}
        validateInputFields={validateInputFields}
        ProvisionDetails={
          <div style={{ width: '100%', height: 'auto', color: '#888888', fontSize: '1rem', fontWeight: '500' }}>
            <form>
              <Grid container spacing={2}>
                {/* SAP Contract ID - First for CLIENT configurations */}
                {!config && (
                  <>
                    <Grid item xs={4}>
                      {FormField.SAPContractCodeField(
                        handleChange,
                        values, // Use Redux values instead of formData
                        sapContractCodeLength,
                        isExternalClientLoading,
                        externalClientError,
                        externalClientData
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                    </Grid>

                    {/* Client Name Field - Only show when validated */}
                    {externalClientData && externalClientData.length >= 2 && sapContractCodeLength === "10" && !externalClientError && !isExternalClientLoading && (
                      <Grid item xs={4}>
                        <StyledDefaultTextField
                          label="Client Name"
                          value={values.ClientName || ''}
                          onChange={(e) => handleChange(e, "ClientName")}
                          variant="outlined"
                          margin="dense"
                          disabled={true}
                        />
                      </Grid>
                    )}

                    {/* End-to-End UID Field - Only show when validated */}
                    {externalClientData && externalClientData.length >= 2 && sapContractCodeLength === "10" && !externalClientError && !isExternalClientLoading && (
                      <Grid item xs={4}>
                        <StyledDefaultTextField
                          label="End-to-End UID"
                          value={values.EndToEndUId || ''}
                          onChange={(e) => handleChange(e, "EndToEndUId")}
                          variant="outlined"
                          margin="dense"
                          disabled={true}
                        />
                      </Grid>
                    )}
                  </>
                )}

                {/* WBSE Code */}
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, formData, isWBSECodeValid, isWBSEValid, isLoading)}
                </Grid>


                {/* LLM Provider */}
                <Grid item xs={4}>
                  {FormField.LLMProviderField(handleChange, formData)}
                </Grid>

                {/* Deployment Lead */}
                <Grid item xs={4}>
                  {FormField.DeploymentLeadField(handleChange, formData)}
                </Grid>

                {/* Delivery Lead */}
                <Grid item xs={4}>
                  {FormField.DeliveryLeadField(handleChange, formData)}
                </Grid>

                {/* Secondary POC */}
                <Grid item xs={4}>
                  {FormField.SecondaryContact(handleChange, formData, config)}
                </Grid>

                {/* Service End Date */}
                <Grid item xs={4}>
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={formData.TentativeServiceEndDate}
                    selectedEnvironment="enabled" // Keep enabled
                    isServiceEndDateInvalid={false}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={(date, fieldName) => {
                      setFormData({ ...formData, TentativeServiceEndDate: date });
                    }}
                    label="Service End Date"
                    idkey="TentativeServiceEndDate"
                  />
                </Grid>

                {/* Cloud Platform */}
                <Grid item xs={4}>
                  {PlatformFormField.CloudPlatformField(
                    formData,
                    handleChange,
                    isGDPR
                  )}
                </Grid>

                {/* Connectivity Type - Only show when CloudPlatform is AWS */}
                {formData.CloudPlatform === 'aws' && (
                  <Grid item xs={4}>
                    {PlatformFormField.ConnectivityType(
                      formData,
                      handleChange,
                      isGDPR
                    )}
                  </Grid>
                )}

                {/* GDPR */}
                <Grid item xs={12}>
                  {PlatformFormField.GDPRPlatformField(
                    formData,
                    handleChange,
                    formData && formData.GDPR === "yes",
                    classes,
                    config,
                    isChecked,
                    externalClientData
                  )}
                </Grid>

                {/* Deployment Region */}
                <Grid item xs={4}>
                  {PlatformFormField.DeploymentRegionDedicatedVirtualNetworkField(
                    formData,
                    handleChange,
                    isGDPR
                  )}
                </Grid>

                {/* Force complete new row by using xs=12 break */}
                <Grid item xs={12} style={{ height: '0px' }}></Grid>

                {/* Applications To Provision - guaranteed new row below connectivity */}
                <Grid item xs={4}>
                  <StyledFormControl variant="outlined" margin="dense">
                    <FormLabel component="legend" style={{ paddingTop: "10px", marginBottom: "16px" }}>
                      Applications To Provision
                    </FormLabel>
                    <FormGroup>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ paddingTop: "10px", margin: 0 }}
                              control={
                                <Checkbox
                                  checked={KM}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="KM" />
                              }
                              label="Knowledge Manager"
                            />
                            <div>
                              {renderInstanceTypeSelection('KM', 'Knowledge Manager')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={Steward}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="Steward"
                                />
                              }
                              label="Steward"
                            />
                            <div>
                              {renderInstanceTypeSelection('Steward', 'Steward')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={CUI}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="CUI"
                                />
                              }
                              label="CUI"
                            />
                            <div>
                              {renderInstanceTypeSelection('CUI', 'CUI')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={ATR}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="ATR"
                                />
                              }
                              label="ATR"
                            />
                            <div>
                              {renderInstanceTypeSelection('ATR', 'ATR')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={Codev}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="Codev"
                                />
                              }
                              label="Codev"
                            />
                            <div>
                              {renderInstanceTypeSelection('Codev', 'Codev')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={SplunkTA}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="SplunkTA"
                                />
                              }
                              label="Splunk TA"
                            />
                            <div>
                              {renderInstanceTypeSelection('SplunkTA', 'Splunk TA')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={AgentManager}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="AgentManager"
                                />
                              }
                              label="Agent Manager"
                            />
                            <div>
                              {renderInstanceTypeSelection('AgentManager', 'Agent Manager')}
                            </div>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '2px 0' }}>
                            <FormControlLabel
                              style={{ margin: 0 }}
                              control={
                                <Checkbox
                                  checked={EventOps}
                                  onChange={(e) => handleChange(e, "Apps")}
                                  name="EventOps"
                                />
                              }
                              label="EventOps"
                            />
                            <div>
                              {renderInstanceTypeSelection('EventOps', 'EventOps')}
                            </div>
                          </div>
                        </div>
                      </FormGroup>
                    </StyledFormControl>
                </Grid>

                {/* Request Notes Field */}
                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    formData,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>

            </form>
            {(formData.vpnPattern !== "") &&
              <Grid container spacing={2}>
                <div style={{ width: 'calc(100% - 20px)', margin: '10px 0px', backgroundColor: '#FFFFFF', position: 'relative' }}>
                  <button
                    style={{ transition: '300ms linear', cursor: 'pointer', backgroundColor: 'transparent', position: 'absolute', top: '10px', right: '0px', border: 'none', transform: expandDetails ? 'rotate(0deg)' : 'rotate(180deg)' }}
                    onClick={() => setExpandDetails(prev => (!prev))}
                  >
                    <ExpandLess style={{ fontSize: '3rem', color: '#888888' }} />
                  </button>
                  <h2 style={{ fontWeight: '500' }}>Connection Information</h2>
                  <div style={{ display: expandDetails ? 'block' : 'none' }}>
                    {renderWorkflowGuide()}
                  </div>
                </div>
              </Grid>
            }
          </div>

        }
        productname={'DedicatedVirtualNetworkSetup'}
        history={history}
        customurl={`https://dedicatedvirtualnetworksetup.genwizardsd.com`}
        NoConfig={true}
      ></GeneralForm>

      {/* Validation Error Dialog */}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
        showStepNumbers={false}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  isWBSEValid: state.fui.isWBSEValid,
  values: state.fui.CPForm,
  configurationType: state.fui.configurationType,
  email: state.auth.userDetails.email,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
  updateCPForm: fuiRedux.updateCPForm,
  fetchExternalClientDetails,
  checkIsWBSEValid
})(withRouter(DedicatedVirtualNetworkSetup));
